interface StatusTagProps {
  status: string;
  type?: 'priority' | 'stage' | 'heat' | 'general';
}

const priorityMap: Record<string, { color: string; bg: string }> = {
  '高': { color: 'text-red-600', bg: 'bg-red-50' },
  '中': { color: 'text-amber-600', bg: 'bg-amber-50' },
  '低': { color: 'text-secondary-600', bg: 'bg-secondary-50' },
};

const stageMap: Record<string, { color: string; bg: string }> = {
  '规划': { color: 'text-secondary-600', bg: 'bg-secondary-100' },
  '执行': { color: 'text-primary-600', bg: 'bg-primary-100' },
  '等待': { color: 'text-amber-600', bg: 'bg-amber-100' },
  '复盘': { color: 'text-accent-600', bg: 'bg-accent-100' },
  '完成': { color: 'text-accent-700', bg: 'bg-accent-100' },
};

const heatMap: Record<string, { color: string; bg: string }> = {
  '高': { color: 'text-red-600', bg: 'bg-red-50' },
  '中': { color: 'text-amber-600', bg: 'bg-amber-50' },
  '低': { color: 'text-foreground-500', bg: 'bg-secondary-50' },
};

export default function StatusTag({ status, type = 'general' }: StatusTagProps) {
  let config = { color: 'text-secondary-600', bg: 'bg-secondary-100' };

  if (type === 'priority') config = priorityMap[status] || config;
  else if (type === 'stage') config = stageMap[status] || config;
  else if (type === 'heat') config = heatMap[status] || config;

  return (
    <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${config.bg} ${config.color}`}>
      {status}
    </span>
  );
}